import _export from '../internals/export.js';
import descriptors from '../internals/descriptors.js';
import objectPrototypeAccessorsForced from '../internals/object-prototype-accessors-forced.js';
import aCallable$1 from '../internals/a-callable.js';
import toObject$1 from '../internals/to-object.js';
import '../internals/object-define-property.js';
import { __exports as objectDefineProperty } from '../../../../../../_virtual/object-define-property.js';

var $ = _export;
var DESCRIPTORS = descriptors;
var FORCED = objectPrototypeAccessorsForced;
var aCallable = aCallable$1;
var toObject = toObject$1;
var definePropertyModule = objectDefineProperty; // `Object.prototype.__defineGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineGetter__

if (DESCRIPTORS) {
  $({
    target: 'Object',
    proto: true,
    forced: FORCED
  }, {
    __defineGetter__: function __defineGetter__(P, getter) {
      definePropertyModule.f(toObject(this), P, {
        get: aCallable(getter),
        enumerable: true,
        configurable: true
      });
    }
  });
}
